var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63542 9.77762C1.56944 9.59987 1.56944 9.40436 1.63542 9.22662C2.27802 7.6685 3.36879 6.33627 4.76945 5.39883C6.17011 4.46138 7.81758 3.96094 9.503 3.96094C11.1884 3.96094 12.8359 4.46138 14.2366 5.39883C15.6372 6.33627 16.728 7.6685 17.3706 9.22662C17.4366 9.40436 17.4366 9.59987 17.3706 9.77762C16.728 11.3357 15.6372 12.668 14.2366 13.6054C12.8359 14.5428 11.1884 15.0433 9.503 15.0433C7.81758 15.0433 6.17011 14.5428 4.76945 13.6054C3.36879 12.668 2.27802 11.3357 1.63542 9.77762Z",
    stroke: "#707494",
    strokeWidth: 1.38542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.875C10.8117 11.875 11.875 10.8117 11.875 9.5C11.875 8.18832 10.8117 7.125 9.5 7.125C8.18832 7.125 7.125 8.18832 7.125 9.5C7.125 10.8117 8.18832 11.875 9.5 11.875Z",
    stroke: "#707494",
    strokeWidth: 1.38542,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon2);
export default __webpack_public_path__ + "static/media/EyeIcon2.6737708d1c9bff2e629ea50408e3c6be.svg";
export { ForwardRef as ReactComponent };